import { CancelTokenSource } from "axios";

import { API } from "utils/api-config";
import { handleApiResponse } from "utils/api-request-cancellation";

import { defaultErrorResponse } from "api/defaults";

import { ISearchService } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export const loadSearchServices = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[ISearchService[] | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `environments/${environmentId}/tenants/${tenantId}/search-services`;
    const response = await API.get(routeUrl, {
        cancelToken: cancelTokenSource?.token,
    });

    return handleApiResponse(response, cancelTokenSource);
};

export const loadSearchServiceLinked = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[ISearchService | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `environments/${environmentId}/tenants/${tenantId}/search-services/linked`;
    const response = await API.get(routeUrl, {
        cancelToken: cancelTokenSource?.token,
    });

    return handleApiResponse(response, cancelTokenSource);
};

export const recreateSearchIndex = async (
    environmentId: string,
    tenantId: string
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `/environments/${environmentId}/tenants/${tenantId}/search-services/default/indexes/default/recreate`;
    const response = await API.post(routeUrl);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};

export const updateSearchIndex = async (
    environmentId: string,
    tenantId: string
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const routeUrl = `/environments/${environmentId}/tenants/${tenantId}/search-services/default/indexes/default/update`;
    const response = await API.post(routeUrl);

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
